import React, { useEffect, useState } from "react";
import "./Header.css";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Image from "react-bootstrap/Image";
// Import Images
import Logo2 from "../../assets/logo2.jpeg";
import wa from "../../assets/wawhitebkg.png";
// Import Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Header = () => {
  const [size, setSize] = useState({ width: 200, height: 90 });
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 992) {
        setSize({ width: 110, height: 50 });
      } else {
        setSize({ width: 200, height: 90 });
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Llama a handleResize al cargar la página para establecer el tamaño inicial

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleNavLinkClick = (event, targetId, offset) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <Navbar
        bg="dark"
        data-bs-theme="light"
        sticky="top"
        collapseOnSelect
        expand="lg"
        className="bg-body-tertiary"
      >
        <Container className="d-flex align-items-center justify-content-between navbar-h">
          <Navbar.Brand href="#home" className="d-flex align-items-center">
            <img
              alt=""
              src={Logo2}
              width={size.width}
              height={size.height}
              className="me-3"
            />{" "}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav nav-col">
            <Nav className="ms-auto">
              <Nav.Link
                href="#aboutus"
                className="text-dark text-uppercase fw-bold fs-5 nav-link"
                onClick={(e) => handleNavLinkClick(e, "aboutus", 100)}
              >
                CONOCENOS
              </Nav.Link>
              <Nav.Link
                href="#features"
                className="text-dark text-uppercase fw-bold fs-5 nav-link"
                onClick={(e) => handleNavLinkClick(e, "gallery", 100)}
              >
                GALERIA
              </Nav.Link>
              <Nav.Link
                href="#plans"
                className="text-dark text-uppercase fw-bold fs-5 nav-link"
                onClick={(e) => handleNavLinkClick(e, "plans", 30)}
              >
                Planes
              </Nav.Link>
              <Nav.Link
                href="#contact"
                className="text-dark text-uppercase fw-bold fs-5 nav-link"
                onClick={(e) => handleNavLinkClick(e, "contact", 100)}
              >
                CONTACTO
              </Nav.Link>
              <a
                href="https://wa.me/+59893961919"
                target="_blank"
                rel="noreferrer"
              >
                <Image src={wa} roundedCircle className="wa-h" />
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <a
        href="https://wa.me/+59893961919"
        class="float"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={faWhatsapp} className="my-float" />
      </a>
    </>
  );
};

export default Header;
